//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import head from 'lodash/head'
import {
  DELIVERY_DETAILS_REDESIGN_VIEW,
  DELIVERY_DETAILS_VIEW,
  ORDER_OK_VIEW,
  PAYMENT_DETAILS_VIEW,
  PAYMENT_REDESIGN_DETAILS_VIEW,
  SHOPCART_DISPLAY_VIEW,
} from '@/scripts/constants/pages'
import { SCARCITY } from '@/scripts/constants/promos'
import { formatTime, sortPromos } from '@/scripts/libs/sort-promos'
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import wcs from '@/scripts/libs/wcs'
import {
  CATALOG_ID,
  LANG_ID,
  STORE_ID,
  ORDER_ID,
  FROM_PAGE_NAME,
} from '@/scripts/constants/parameters'
import { ZERO_PLACEHOLDER, ONE_PLACEHOLDER } from '@/scripts/constants/placeholders'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import RbDate from '@/utils/rb-date'
import { REMIX, ROX_FRAME } from '@/scripts/constants/pdp'

const { storeId, catalogId, langId, flashSale, viewTaskName, locale, currencySymbol } =
  wcs.getStoreConfig()
const HASH_COUNTDOWN_END = '#countdown_end'
const checkoutPages = [
  DELIVERY_DETAILS_REDESIGN_VIEW,
  DELIVERY_DETAILS_VIEW,
  ORDER_OK_VIEW,
  PAYMENT_DETAILS_VIEW,
  PAYMENT_REDESIGN_DETAILS_VIEW,
]

export default {
  name: 'rb-scarcity-bar',
  props: {
    partNumber: {
      type: String,
      default: '',
    },
    // TODO: change this name, it is a single catEntryId
    catEntries: {
      type: String,
      default: '',
    },
    orderItemId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      storeId: storeId,
      catalogId: catalogId,
      langId: langId,

      currentPromo: '',
      productStylesJSONView: null,
      priceArray: null,
      savedAmount: '',
      timerInterval: null,
      formattedTimeRemain: '',
      canShowCountdown: false,
      remains: 1,
      isCountdownRed: false,
      isBarRed: false,
      isCheckoutPage: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapState({
      cartSaved: (state) => state.sidebar.cart,
      cartItems: (state) => state.sidebar.cart.items,
    }),
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isJapan() {
      return storeId === WcsStoreId.JAPAN
    },
    currentProduct() {
      return this.cartItems.find((item) => item.orderItemId === this.orderItemId)
    },
    isPromoScarcity() {
      return this.currentPromo?.type === SCARCITY
    },
    isPromoRunning() {
      const currentDate = RbDate.getTimeDate()
      return currentDate > this.currentPromo?.startDate && currentDate < this.currentPromo?.endDate
    },
    canShowScarcityBar() {
      if (
        Object.keys(this.cartSaved?.promotionDetails).length === 0 ||
        (!this.currentProduct?.listPrice && !this.currentProduct?.orderItemOfferPrice)
      ) {
        return false
      }
      return this.isPromoRunning || this.hasGenericPromotionActive()
    },
    getScarcityBarText() {
      const formattedSavedAmount = this.savedAmount
        ? this.formatSavedAmountByCountry(this.savedAmount, locale)
        : ''

      if (this.currentPromo?.type === SCARCITY) {
        const templateText = this.translation('scarcity.flashSalePromoMessage')
        let outputText = templateText.replace(`${ZERO_PLACEHOLDER} - `, '')
        outputText = outputText.replace(ONE_PLACEHOLDER, formattedSavedAmount)
        if (this.isMobile || this.isCheckoutPage) {
          outputText = outputText.replace('-', '<br>')
        }
        return outputText
      }

      const templateText = this.translation('scarcity.pstPromoMessage')
      const outputText = templateText.replace(`${ZERO_PLACEHOLDER} - `, '')
      return templateText.includes(ONE_PLACEHOLDER)
        ? outputText.replace(ONE_PLACEHOLDER, formattedSavedAmount)
        : `${outputText} ${formattedSavedAmount}`
    },
    getScarcityBarClasses() {
      return {
        ['rb-scarcity-bar--red']: this.isBarRed,
        ['rb-scarcity-bar--visible-countdown']: this.canShowCountdown,
        ['rb-scarcity-bar--not-visible-countdown']: !this.canShowCountdown,
      }
    },
  },
  watch: {
    cartItems() {
      this.calculateSavedAmount()
    },
  },
  async mounted() {
    this.calculateSavedAmount()
    this.isCheckoutPage = checkoutPages?.includes(viewTaskName)

    await this.fetchProductDetails()
    if (!Array.isArray(this.priceArray) || this.priceArray.length === 0) {
      return
    }

    const currentPromo = head(this.priceArray)
    if (!currentPromo) {
      return
    }

    this.currentPromo = currentPromo
    if (this.currentProduct?.producType === REMIX) {
      return
    }

    this.calculateSavedAmount()

    if (!this.canShowScarcityBar) {
      return
    }

    if (this.isPromoScarcity) {
      this.canShowCountdown = true
    }

    this.remains = parseInt((currentPromo.endDate - RbDate.getTimeDate()) / 1000) + 1
    this.startScarcityCountdown()
  },
  destroyed() {
    clearInterval(this.timerInterval)
  },
  methods: {
    async fetchProductDetails() {
      const endpoint = wcs.getEndPoint('pdp').replace('$catalogEntryId', this.catEntries)
      const { data: productData } = await axios.get(endpoint)

      this.productStylesJSONView = head(Object.values(productData))
      this.priceArray = sortPromos(this.productStylesJSONView?.promotions)
    },
    calculateSavedAmount() {
      const itemQuantity = this.currentProduct?.orderItemCount
      const listPrice = this.currentProduct?.listPrice
      const price = this.currentProduct?.price
      const priceFormat = this.productStylesJSONView?.prices?.priceFormat
      const pricePlaceholder = '{PRICE}'
      const currencyPlaceholder = '{CURRENCY}'
      const savedAmount = ((listPrice - price) * itemQuantity).toFixed(2)
      const orderItemOfferPrice = this.currentProduct?.orderItemOfferPrice || 0
      const orderItemPrice = this.currentProduct?.orderItemPrice || 0

      if (
        this.currentProduct?.producType === REMIX ||
        this.currentProduct?.producType === ROX_FRAME
      ) {
        const updatedSavedAmount = ((orderItemPrice - orderItemOfferPrice) * itemQuantity).toFixed(
          2
        )
        this.savedAmount = updatedSavedAmount
      } else {
        const cleanedSavedAmount = priceFormat
          ?.replace(pricePlaceholder, savedAmount)
          ?.replace(currencyPlaceholder, this.productStylesJSONView?.prices?.currencySymbol)
        this.savedAmount = cleanedSavedAmount
      }
    },
    startScarcityCountdown() {
      this.timerInterval = setInterval(async () => {
        this.remains -= 1

        if (this.remains > 0) {
          const dayLabel = this.$t('common.day')
          const daysLabel = this.$t('common.days')
          this.formattedTimeRemain = formatTime(this.remains * 1000, dayLabel, daysLabel)
          if (this.remains <= flashSale.redCountdownStart) {
            this.isCountdownRed = true
          }
          if (this.remains <= flashSale.redIconStart) {
            this.isBarRed = true
          }
        } else if (this.remains === 0) {
          this.trackFlashsaleIsOver()
          this.canShowCountdown = false
          const origin = window.location.origin
          const fromPageName = `${FROM_PAGE_NAME}=${window.location.pathname}`
          const catalogId = `${CATALOG_ID}=${this.catalogId}`
          const langId = `${LANG_ID}=${this.langId}`
          const storeId = `${STORE_ID}=${this.storeId}`
          const orderId = `${ORDER_ID}=${
            document.getElementById(ORDER_ID)?.value ||
            document.querySelector('input[name=orderId]').value
          }`
          const urlAjaxOrderCalculate = `AjaxOrderCalculate?${orderId}&calculationUsageId=-1&${catalogId}&${langId}&${storeId}`
          await axios.get(urlAjaxOrderCalculate)
          const urlToReload = `${origin}/${SHOPCART_DISPLAY_VIEW}?${fromPageName}&${catalogId}&${langId}&${storeId}&${orderId}${HASH_COUNTDOWN_END}`
          if (window.location.href.indexOf(HASH_COUNTDOWN_END) > -1) {
            window.location.reload()
          } else {
            window.location.replace(urlToReload)
          }
        }
      }, 1000)
    },
    canShowSavedAmount() {
      return this.currentPromo?.badge?.includes('%')
    },
    hasGenericPromotionActive() {
      if (this.currentProduct?.producType === REMIX) {
        const orderItemOfferPrice = this.currentProduct?.orderItemOfferPrice
        const orderItemPrice = this.currentProduct?.orderItemPrice
        return orderItemPrice && orderItemOfferPrice && +orderItemOfferPrice < +orderItemPrice
      }
      const listPrice = this.currentProduct?.listPrice
      const price = this.currentProduct?.price
      return listPrice && price && +price < +listPrice
    },
    trackFlashsaleIsOver() {
      if (this.canShowCountdown) {
        this.$ma.trackEvent({
          event: 'Error',
          value: {
            id: 'Error',
            Error_Source: 'Product',
            Error_Code: 'UpcSupportedError',
            Error_Message: 'Flash sale is over',
          },
        })
      }
    },
    formatSavedAmountByCountry(savedAmount, locale) {
      const { currency, priceNumber } = this.extractCurrencyAndPriceNumber(savedAmount)
      const formattedPrice = priceNumber.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      return currency + formattedPrice
    },
    extractCurrencyAndPriceNumber(priceLabel) {
      const price = priceLabel.replace(currencySymbol, '')
      return {
        currency: currencySymbol,
        priceNumber: parseFloat(price),
      }
    },
  },
}
